// EditRole — modal-embedded form for updating a Role row.
// Refactored 2026-05-05 (Phase 3.1, Class P) onto ModalFormHeader.

import { useState } from "react";
import CTextField from "../CTextField/CTextField";
import { Button, Stack, Box, Typography } from "@mui/material";
import { AdminPanelSettingsOutlined } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { updateRole } from "../../feature/roleSlice";
import CMultiSelect from "../CMutiSelect/CMultiSelect";
import { toast } from "react-toastify";
import CSwitch from "../CSwitch/CSwitch";
import { ModalFormHeader, FieldLabel } from "../PaperForm";

const EditRole = (props) => {
  const { id, name, permissions, isNotification } = props.data;
  const dispatch = useDispatch();
  // CR-2026-AUTHZ-KEYS: always a list (the server refuses a non-list; it never reads it as "remove all").
  let rolePermissions = Array.isArray(permissions) ? permissions.map((item) => item.id) : [];
  const [selectedPermissions, setSelectedPermissions] = useState(rolePermissions);
  const [notificationEnabled, setNotificationEnabled] = useState(isNotification);
  const [data, setData] = useState({
    roleId: id,
    name,
    isNotification,
  });

  const handleChange = (event) => {
    setData((prv) => ({ ...prv, [event.target.name]: event.target.value }));
  };

  const handleSubmit = () => {
    dispatch(
      updateRole({
        ...data,
        permissions: selectedPermissions,
        isNotification: notificationEnabled,
      })
    ).then((res) => {
      if (res.type === "updateRoles/roles/fulfilled") {
        props.setOpen(false);
        toast("Role updated successfully!");
      }
    });
  };

  return (
    <Box>
      <ModalFormHeader
        overline="SFM · Role"
        title="Update Role"
        icon={AdminPanelSettingsOutlined}
      />
      <Box sx={{ overflowY: "auto", maxHeight: "450px" }}>
        <Stack spacing={2}>
          <CTextField
            onChange={handleChange}
            defaultValue={name}
            name="name"
            label="Role name"
          />
          <Box>
            <FieldLabel hint="select all that apply">Permissions</FieldLabel>
            <CMultiSelect
              data={props.permissions}
              permission={props.data.permissions}
              selectedPermissions={setSelectedPermissions}
            />
          </Box>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 600 }}>
              Notifications
            </Typography>
            <CSwitch
              active={notificationEnabled}
              name="orderArrivedInFull"
              setSwitch={() => setNotificationEnabled(!notificationEnabled)}
            />
          </Stack>
          <Button
            onClick={handleSubmit}
            variant="contained"
            sx={{
              width: "100%",
              mt: 1,
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
              letterSpacing: "0.01em",
            }}
          >
            Save changes
          </Button>
        </Stack>
      </Box>
    </Box>
  );
};

export default EditRole;
